// extracted by mini-css-extract-plugin
module.exports = {"webcamShareHolder":"WebcamShare_webcamShareHolder__3uxWd","webcamPreviewHolder":"WebcamShare_webcamPreviewHolder__3pj67"};